
export default class Data {
    constructor(Model) {
        this.Model = Model;
    }

    async reload() {
        this.data = new Promise((resolve, reject) => {
            this.Model.get().then(resolve, reject);
        });

        return this.data;
    }

    async all() {
        if (!this.data) {
            return this.reload();
        }

        return this.data;
    }

    async clear() {
        delete this.data;
    }

    async find(id) {
        return (await this.all()).find(item => item[new this.Model().primaryKey()] === id);
    }

    async findResource(id) {
        const model = new this.Model();

        return (await this.all()).find(
            item => item[model.primaryKey()] === id.substr(model.resource().length + 2),
        );
    }
}
